
import {createDynamoDbClient} from './connect';

export const listTables = async (target) => {

    const dynamodb = createDynamoDbClient(null, target);
    let err;

    const data = await dynamodb.listTables()
        .promise()
            .catch((error) => {
                // alert(JSON.stringify(error.message));
                err = error.message;

            });

    if(err) {
        return err;
    } else {
        return data.TableNames;
    }

};

export const getTableMetadata = async (target, table) => {
    const dynamodb = createDynamoDbClient(null, target);

    const data = await dynamodb.describeTable({TableName:table}).promise();

    return data;

};


export const getItems = async (connection, operation, keys) => {
    let data;

    const docClient = createDynamoDbClient('doc', connection);
    const pkName = keys && keys.length > 0 ? keys[0] : null;
    const skName = keys && keys.length > 1 ? keys[1] : null;

    console.log('getItems called! \n' + JSON.stringify(operation, null, 2));
    console.log('ESK: ' + operation.ExclusiveStartKey);
    
    switch (operation.action) {

        case 'scan':
            const paramsScan = {
                TableName:operation.target,
                IndexName: operation.index || null,
                ExclusiveStartKey: operation.LastEvaluatedKey,
                ReturnConsumedCapacity: 'TOTAL'
            };

            data = await docClient.scan(paramsScan).promise();

            return data;

        case 'query':


            let kce = '#legalword=:pk ' ;

            let ean = { '#legalword': pkName };
            let eav = {':pk' : operation.pk};


            if(operation.index && operation.sk) {
                kce += (operation.sk ? 'and #legalword2=:sk ' : '');
                ean['#legalword2'] = skName;
                eav[':sk'] = operation.sk;
            }

            // const kce = '#legalword=:pk';
            // const ean = { '#legalword': pkName };
            // const eav = {':pk' : operation.pk};

            const paramsQuery = {
                TableName:operation.target,
                IndexName: operation.index || null,

                KeyConditionExpression: kce,
                ExpressionAttributeNames: ean,
                ExpressionAttributeValues: eav,

                ReturnConsumedCapacity: 'TOTAL'

            };

            // const paramsQuery = {
            //     TableName: operation.target,
            //     IndexName: operation.index || null,
            //     KeyConditionExpression: '#legalword=:pk ' + (operation.index ? ' and #legalword2=:sk ' : ''),
            //     ExpressionAttributeNames: {'#legalword': pkName, '#legalword2': skName},
            //     ExpressionAttributeValues: {':pk': operation.pk, ':sk': operation.sk},
            //     ReturnConsumedCapacity: 'TOTAL'
            // };

            data = await docClient.query(paramsQuery).promise();

            return data;

        case 'get':

            const paramsGet = {
                TableName:operation.target,
                Key: {},
                ReturnConsumedCapacity: 'TOTAL'
            };

            paramsGet.Key[pkName] = operation.pk;

            if(skName) {
                paramsGet.Key[skName] = operation.sk;
            }

            // console.log('params\n' + JSON.stringify(params, null, 2));

            data = await docClient.get(paramsGet).promise();

            // console.log('operation: ' + JSON.stringify(operation));

            // console.log('data::\n' + JSON.stringify(data, null, 2));

            return data;

        default:
            return null;
    }

};

export const getStreams = async (connection, operation) => {

    const streamsClient = createDynamoDbClient('streams', connection);

    const streamsList = await streamsClient.listStreams({TableName:operation.target}).promise();

    let myStream;
    let sd;

    if(streamsList && streamsList.Streams && streamsList.Streams.length > 0) {

        myStream = streamsList.Streams.filter((item) => {
            return item.TableName === operation.target;
        });

        if(myStream.length > 0) {
            const params = {StreamArn: myStream[0].StreamArn};

            sd = await streamsClient.describeStream(params).promise();

            // console.log('hello ' + JSON.stringify(sd,null,2));
        }
    }

    if(sd && sd.StreamDescription) {

        return sd.StreamDescription;

    } else {
        return null;
    }

};

export const getShardIterator = async (connection, shardParams) => {
    // console.log('getting Shard Iterator');

    const streamsClient = createDynamoDbClient('streams', connection);

    const si = await streamsClient.getShardIterator(shardParams).promise();

    return si;

};

export const getShardRecords = async (connection, getRecordsParams) => {
    // console.log('getting Shards');

    const streamsClient = createDynamoDbClient('streams', connection);

    // const sr = await streamsClient.getShardRecords(getRecordsParams).promise();
    //
    // console.log('#####');
    // console.log(JSON.stringify(getRecordsParams,null,2));

    // console.log(JSON.stringify(getRecordsParams));
    // alert(JSON.stringify(getRecordsParams,null,2));

    const shardRecords = await streamsClient.getRecords(getRecordsParams).promise();

    // console.log('shardRecords !!!\n');
    // console.log(JSON.stringify(shardRecords, null, 2));
    // console.log('\n\n');

    //
    // console.log('got si');
    // console.log(JSON.stringify(si,null,2));

    return shardRecords;

};
